import React__default from 'react';
import { UltimateSpecialOffers } from '../../../innerComponents/UltimateSpecialOffers/src/UltimateSpecialOffers.js';
import '../../../innerComponents/UltimateSpecialOffers/src/constants/labels.js';

const SOVerticalWidget = ({ tab, ...props }) => {
    return (React__default.createElement(UltimateSpecialOffers, { ...props, showOneHorizontalTabHeading: false, tabs: [tab], isWithLinkToAll: false, type: 'verticalList' }));
};

export { SOVerticalWidget };
//# sourceMappingURL=SOVerticalWidget.js.map
